export const TEMPLATE_EDITOR_DEFAULT_PERCENTAGE = 50; // Percent (50/50 each)
export const TEMPLATE_EDITOR_SPLIT_CONTAINER_CSS_ID = 'split-pane-container';
export const TEMPLATE_EDITOR_THEME_STORAGE_ID = 'templateEditorTheme';
export const TEMPLATE_EDITOR_WORD_WRAP_STORAGE_ID = 'templateEditorWordWrap';
export const TEMPLATE_EDITOR_MOBILE_SIZE_STORAGE_ID = 'templateEditorMobileSize';
export const TEMPLATE_EDITOR_DESKTOP_SIZE_STORAGE_ID = 'templateEditorDesktopSize';
export const TEMPLATE_EDITOR_FAKE_CC_ID = 'b283a6cd-56e8-4f27-9f30-e87488098664';
export const TEMPLATE_EDITOR_FAKE_MACHINEGUID = 'b283a6cd-56e8-4f27-9f30-d76377087553';
export const monacoThemes = [
  { id: 'light', label: 'light' },
  { id: 'vs-dark', label: 'vs-dark' },
];

export enum TemplateEditorTabs {
  templateInput = 'templateInput',
  compilationContextInput = 'compilationContextInput',
  templatePreview = 'templatePreview',
  linkConfig = 'linkConfig',
  templateOutput = 'templateOutput',
  codeValidation = 'codeValidation',
  linkOutput = 'linkOutput',
  templateConvert = 'templateConvert',
  compilationContextListInput = 'compilationContextListInput',
  templateHistory = 'templateHistory',
  validationMessage = 'validationMessage',
}
